module.exports = __webpack_public_path__ + "assets/sharethis.03d5962c.svg";